import styled, { css } from 'styled-components';

export const AnswerWrapper = styled.div<{ $isCorrect: boolean; $isChecked: boolean }>`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid;

  ${({ $isCorrect, $isChecked }) => {
    if ($isCorrect) {
      return css`
        background-color: ${({ theme }) => theme.colors.green1};
        border-color: ${({ theme }) => theme.colors.green6};
      `;
    }
    if ($isChecked && !$isCorrect) {
      return css`
        background-color: ${({ theme }) => theme.colors.red1};
        border-color: ${({ theme }) => theme.colors.red6};
      `;
    }
    return css`
      background-color: ${({ theme }) => theme.colors.white};
      border-color: ${({ theme }) => theme.colors.black4};
    `;
  }}
  .ant-radio-checked .ant-radio-inner {
    background-color: ${({ theme }) => theme.colors.green6};
    border-color: ${({ theme }) => theme.colors.green6};
  }
`;

export const FormulaWrapper = styled.div`
  display: flex;
`;

export const StyledImage = styled.img`
  width: fit-content;
  max-width: 100%;
`;

export const ResponseText = styled.p`
  margin: 0;
  flex-grow: 1;
  text-align: left;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
